import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import { Card, Textarea } from '../shared';

export default function TabPrompt({ formData, handleChange, promptPreview, setPromptPreview }) {
    return (
        <div className="space-y-4">
            <Card title="System Prompt">
                <div className="flex justify-end mb-2">
                    <div className="flex rounded-md border border-gray-200 overflow-hidden text-xs">
                        <button
                            type="button"
                            className={`px-3 py-1.5 font-medium transition-colors ${!promptPreview ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}
                            onClick={() => setPromptPreview(false)}
                        >
                            Edit
                        </button>
                        <button
                            type="button"
                            className={`px-3 py-1.5 font-medium transition-colors border-l border-gray-200 ${promptPreview ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}
                            onClick={() => setPromptPreview(true)}
                        >
                            Preview
                        </button>
                    </div>
                </div>
                {promptPreview ? (
                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 min-h-[32rem] overflow-y-auto max-h-[70vh] prose prose-sm max-w-none text-gray-800">
                        {formData.system_prompt
                            ? <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>{formData.system_prompt}</ReactMarkdown>
                            : <span className="text-gray-400 italic">Nothing to preview</span>
                        }
                    </div>
                ) : (
                    <Textarea
                        monospace rows={24}
                        value={formData.system_prompt || ''}
                        onChange={(e) => handleChange('system_prompt', e.target.value)}
                        placeholder="Enter system prompt..."
                    />
                )}
                {formData.system_prompt && (
                    <div className="flex justify-end gap-3 mt-1.5 text-xs text-gray-400">
                        <span>{formData.system_prompt.length.toLocaleString()} chars</span>
                        <span>~{Math.ceil(formData.system_prompt.length / 4).toLocaleString()} tokens</span>
                    </div>
                )}
            </Card>
        </div>
    );
}
